<app-modal>
    <form class="form">
        <div class="form_group">
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Сумма</div>
                <div class="col-17"><input [(ngModel)]="formProlongSubscription.price" name="amount" type="number" class="inp"
                        placeholder="Введите сумму"></div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Валюта</div>
                <div class="col-17">
                    <select [(ngModel)]="formProlongSubscription.currency" name="currency" class="inp">
                        <option value="usd">$</option>
                        <option value="eur">€</option>
                    </select>
                </div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Дата окончания</div>
                <div class="col-17"><input [(ngModel)]="formProlongSubscription.expiresAt" [locale]="dateLocaleService.locale" (change)="calculateDays($event)" [timePicker]="true" [singleDatePicker]="true"  name="date" [min]="todayDate" ngxDaterangepickerMd
                    class="inp" placeholder="2025-11-20"></div>
            </label>
            <label *ngIf="daysDifference && daysDifference>0" class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Количество дней:</div>
                <div class="col-17">
                    {{daysDifference}}
                </div>
            </label>
        </div>
        <div class="btns_container row fw_500 fz_s">
            <button class="btn btn_cancel" (click)="closeModal()">Отмена</button>
            <button (click)="prolongSubscription()" [disabled]="isLoadingSend" type="submit" class="btn dark_btn row"><span *ngIf="isLoadingSend" class="loader"></span> <span *ngIf="!isLoadingSend">Продлить</span></button>
        </div>
    </form>
</app-modal>